import { render, staticRenderFns } from "./ArithmeticDash.vue?vue&type=template&id=e22ed9ac&scoped=true"
import script from "./ArithmeticDash.vue?vue&type=script&setup=true&lang=js"
export * from "./ArithmeticDash.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ArithmeticDash.vue?vue&type=style&index=0&id=e22ed9ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22ed9ac",
  null
  
)

export default component.exports